//src/lib/ensureCustomer.js
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

export async function ensureCustomer(tenantId) {

  const fn = httpsCallable(functions, "ensureCustomer");

  const res = await fn({
    tenantId
  });

  return res.data;
}